/* eslint-disable */
import * as React from 'react';
import { Container, Stack, Typography, Card } from '@mui/material';
import Page from '../components/Page';

import { manualUrl } from '../constants';

export default function ManualAdmin() {
  var cardStyle = {
    display: 'block',
    transitionDuration: '0.3s',
    height: '39.3vw'
  };
  return (
    <Page title="Admin Manual | JConnect">
      <Container maxWidth="false">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            คู่มือการใช้งานระบบสาหรับผู้ดูแล
          </Typography>
        </Stack>
        <Card style={cardStyle} sx={{ mt: 2 }}>
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            src={`${manualUrl}/admin_manual.pdf`}
          ></iframe>
        </Card>
      </Container>
    </Page>
  );
}
